export default __webpack_public_path__ + "static/media/location.7d7ad5a9.svg";